{
  "actionbar.actions": "Działania",
  "actionbar.actionsAvailable": "Dostępne działania.",
  "actionbar.clearSelection": "Wyczyść zaznaczenie",
  "actionbar.selected": "Zaznaczono: {count}",
  "actionbar.selectedAll": "Wszystkie zaznaczone",
  "breadcrumbs.more": "Więcej elementów",
  "button.pending": "oczekujące",
  "calendar.invalidSelection": "{selectedCount, plural, one {Wybrana data jest niedostępna} other {Wybrane daty są niedostępne}}.",
  "combobox.noResults": "Brak wyników",
  "contextualhelp.help": "Pomoc",
  "contextualhelp.info": "Informacja",
  "datepicker.endTime": "Godzina końcowa",
  "datepicker.startTime": "Godzina początkowa",
  "datepicker.time": "Godzina",
  "dialog.alert": "Ostrzeżenie",
  "dialog.dismiss": "Zignoruj",
  "dropzone.replaceMessage": "Upuść plik, aby zastąpić",
  "inlinealert.informative": "Informacja",
  "inlinealert.negative": "Błąd",
  "inlinealert.notice": "Ostrzeżenie",
  "inlinealert.positive": "Powodzenie",
  "label.(optional)": "(opcjonalne)",
  "label.(required)": "(wymagane)",
  "menu.moreActions": "Więcej akcji",
  "menu.unavailable": "Niedostępne, rozwiń, aby zobaczyć szczegóły",
  "notificationbadge.indicatorOnly": "Nowa aktywność",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "Zaznacz…",
  "picker.selectedCount": "{count, plural, =0 {Nie zaznaczono żadnych elementów} one {# zaznaczony element} few {# zaznaczone elementy} many {# zaznaczonych elementów} other {# zaznaczonych elementów}}",
  "slider.maximum": "Maksimum",
  "slider.minimum": "Minimum",
  "table.cancel": "Anuluj",
  "table.drag": "Przeciągnij",
  "table.editCell": "Edytuj komórkę",
  "table.loading": "Wczytywanie...",
  "table.loadingMore": "Wczytywanie większej liczby...",
  "table.resizeColumn": "Zmień rozmiar kolumny",
  "table.save": "Zapisz",
  "table.sortAscending": "Sortuj rosnąco",
  "table.sortDescending": "Sortuj malejąco",
  "tag.actions": "Działania",
  "tag.hideButtonLabel": "Wyświetl mniej",
  "tag.noTags": "Brak",
  "tag.showAllButtonLabel": "Pokaż wszystko ({tagCount, number})",
  "toast.clearAll": "Wyczyść wszystko",
  "toast.collapse": "Zwiń",
  "toast.showAll": "Pokaż wszystko"
}
